// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "organizations" + "." + "21f3cb67" + ".chunk.css";
};